import { render, staticRenderFns } from "./BaseFeedbackScreenStructure.vue?vue&type=template&id=1138e33b&scoped=true&"
import script from "./BaseFeedbackScreenStructure.vue?vue&type=script&lang=js&"
export * from "./BaseFeedbackScreenStructure.vue?vue&type=script&lang=js&"
import style0 from "./BaseFeedbackScreenStructure.vue?vue&type=style&index=0&id=1138e33b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138e33b",
  null
  
)

export default component.exports